import { auth } from '../services/authAdmin.js'

async function getBearer() {
  const details = await auth.getIdToken()
  if (
    !details ||
    details.idToken === null ||
    details.idToken === '' ||
    details.idToken === undefined
  ) {
    console.error('failed to grab id token')
    return
  }
  return details.idToken
}

async function getHeaders(contentType) {
  // default to json if we don't declare a value
  if (contentType === undefined) contentType = 'application/json'

  let headers = {
    Authorization: `Bearer ${await getBearer()}`,
  }
  // if we passed in contentType = null then just omit the content type
  if (contentType != null) headers['Content-Type'] = `${contentType}`
  return headers
}

export let get = async function get(url) {
  return await fetch(url, {
    headers: {
      Authorization: `Bearer ${await getBearer()}`,
    },
  })
    .then((response) => response.json())
    .then((data) => data)
}

export let post = async function post(url, data, contentType, returnData) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true

  return await fetch(url, {
    method: 'POST',
    headers: await getHeaders(contentType),
    body: data,
  }).then((response) => {
    if (returnData === true && contentType !== 'text/csv' && response.ok)
      return response.json()
    if (returnData === true && contentType === 'text/csv' && response.ok)
      return response.blob()
    if (returnData === true && !response.ok) return response.json()
    return response.ok
  })
}
export let put = async function put(url, data, contentType, returnData) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true

  return await fetch(url, {
    method: 'PUT',
    headers: await getHeaders(contentType),
    body: data,
  }).then((response) => {
    if (returnData === true)
      return response.status !== 204 ? response.json() : true
    if (returnData === true && !response.ok) return response.json()
    return response.ok
  })
}

export let del = async function del(url, data, contentType, returnData) {
  // default returnData to true
  // most endpoints should return data except for favorites
  if (returnData === undefined) returnData = true
  return await fetch(url, {
    method: 'DELETE',
    headers: await getHeaders(contentType),
    body: data,
  }).then((response) => {
    if (returnData === true)
      return response.status !== 204 ? response.json() : true
    return response.ok
  })
}
